<div class="w-full">
  <div class="flex flex-col mb-2 border-b border-primary-600 header-background h-20 p-2 w-full">
    <div class="flex flex-row text-xs h-6"></div>

    <h1 class="mt-1 flex flex-row gap-1 items-center">
      <ng-icon name="heroPercentBadgeSolid" size="30px" class="text-red-600 mr-2"></ng-icon><span>{{ { key: 'promotion' } | i18n }}</span>
    </h1>
  </div>

  @if (hits | async; as items) {
    <div class="grid auto-cols-fr gap-y-8 md:grid-cols-2 xl:grid-cols-3">
      @for (item of items; track item.objectID; let i = $index) {
        <app-item-list-item [item]="item" [index]="i"></app-item-list-item>
      } @empty {
        <div class="text-gray-800 p-4">{{ { key: 'noEntries' } | i18n }}...</div>
      }
    </div>
  }
</div>
